/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Off_HintInputs */

const en_push_off_hint = /** @type {(inputs: Push_Off_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get these notifications on this device too, even when the app is closed.`)
};

/**
* | output |
* | --- |
* | "Get these notifications on this device too, even when the app is closed." |
*
* @param {Push_Off_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_off_hint = /** @type {((inputs?: Push_Off_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Off_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_off_hint(inputs)
});